const titleList = {
  'home': {
    'zh': 'LuckyWin-首页',
    'en': 'home',
    'vn': 'LuckyWin-Trang chủ',
  },
  'login': {
    'zh': 'LuckyWin-登录页',
    'en': 'login',
    'vn': 'LuckyWin-Trang đăng nhập',
  },
  'mineUserInfo': {
    'zh': 'LuckyWin-个人中心',
    'en': 'mineUserInfo',
    'vn': 'LuckyWin-Trung tâm cá nhân',
  },
  'userList': {
    'zh': 'LuckyWin-用户列表',
    'en': 'userList',
    'vn': 'LuckyWin-Danh sách người dùng',
  },
  'userLogsManage': {
    'zh': 'LuckyWin-用户日志',
    'en': 'userLogsManage',
    'vn': 'LuckyWin-Nhật ký hoạt động',
  },
  'userPortraitList': {
    'zh': 'LuckyWin-头像图库',
    'en': 'userPortraitList',
    'vn': 'LuckyWin-Thư viện hình đại diện',
  },
  'userGroup': {
    'zh': 'LuckyWin-用户组别',
    'en': 'userGroup',
    'vn': 'LuckyWin-Nhóm người dùng',
  },
  'userBlack': {
    'zh': 'LuckyWin-账号黑名单',
    'en': 'userBlack',
    'vn': 'LuckyWin-Danh sách đen tài khoản',
  },
  'otherBlack': {
    'zh': 'LuckyWin-其他黑名单',
    'en': 'otherBlack',
    'vn': 'LuckyWin-Danh sách đen khác',
  },
  'userOnline': {
    'zh': 'LuckyWin-在线用户',
    'en': 'userOnline',
    'vn': 'LuckyWin-người dùng trực tuyến',
  },
  'userAmountLog': {
    'zh': 'LuckyWin-账变记录',
    'en': 'userAmountLog',
    'vn': 'LuckyWin-Lịch sử thay đổi tài khoản',
  },
  'userFileAmountLog': {
    'zh': 'LuckyWin-已归档账变记录',
    'en': 'userAmountLog',
    'vn': 'LuckyWin-Lịch sử thay đổi tài khoản',
  },
  'userForbidden': {
    'zh': 'LuckyWin-禁言管理',
    'en': 'userForbidden',
    'vn': 'LuckyWin-Quản lý cấm',
  },
  'gameClassify': {
    'zh': 'LuckyWin-游戏分类',
    'en': 'gameClassify',
    'vn': 'LuckyWin-Phân loại trò chơi',
  },
  'gameManage': {
    'zh': 'LuckyWin-游戏管理',
    'en': 'gameManage',
    'vn': 'LuckyWin-quản lí game điện tử',
  },
  'gameFishManage': {
    'zh': 'LuckyWin-游戏捕鱼管理',
    'en': 'gameFishManage',
    'vn': 'LuckyWin-Quản lí game bắn cá',
  },
  'gameFishControl': {
    'zh': 'LuckyWin-捕鱼游戏控制',
    'en': 'gameFishControl',
    'vn': 'LuckyWin-Quản lí game bắn cá',
  },
  'gameRobotData': {
    'zh': 'LuckyWin-游戏机器人数据统计',
    'en': 'gameRobotData',
    'vn': 'LuckyWin-Thống kê số liệu người máy game',
  },
  'gameOdds': {
    'zh': 'LuckyWin-游戏赔率',
    'en': 'gameOdds',
    'vn': 'LuckyWin-Tỷ lệ cược',
  },
  'gameQuota': {
    'zh': 'LuckyWin-游戏额度',
    'en': 'gameQuota',
    'vn': 'LuckyWin-Cài đặt hạn mức',
  },
  'gameBlack': {
    'zh': 'LuckyWin-游戏黑名单',
    'en': 'gameBlack',
    'vn': 'LuckyWin-danh sách đen trò chơi',
  },
  'gameJackPotDatas': {
    'zh': 'LuckyWin-JACKPOT奖池记录',
    'en': 'gameJackPotDatas',
    'vn': 'LuckyWin-JACKPOT',
  },
  'orderList': {
    'zh': 'LuckyWin-实时订单列表',
    'en': 'orderList',
    'vn': 'LuckyWin-Danh sách đơn cược',
  },
  'fileList': {
    'zh': 'LuckyWin-已归档订单列表',
    'en': 'fileList',
    'vn': 'LuckyWin-Danh sách đơn cược',
  },
  'openHistory': {
    'zh': 'LuckyWin-开奖记录',
    'en': 'openHistory',
    'vn': 'LuckyWin-Danh sách đơn cược',
  },
  'prizeControl': {
    'zh': 'LuckyWin-开奖控制',
    'en': 'prizeControl',
    'vn': 'LuckyWin-Kiểm soát giải thưởng',
  },
  'gameWinRateConfig': {
    'zh': 'LuckyWin-游戏胜率配置',
    'en': 'gameWinRateConfig',
    'vn': 'LuckyWin-Cấu hình tỷ lệ chiến thắng trò chơi',
  },
  'userControl': {
    'zh': 'LuckyWin-用户控制',
    'en': 'userControl',
    'vn': 'LuckyWin-Kiểm soát người dùng',
  },
  'rollList': {
    'zh': 'LuckyWin-实时滚单列表',
    'en': 'rollList',
    'vn': 'LuckyWin-实时滚单列表',
  },
  'platformNotice': {
    'zh': 'LuckyWin-平台公告',
    'en': 'platformNotice',
    'vn': 'LuckyWin-thông báo nhà cái',
  },
  'adSet': {
    'zh': 'LuckyWin-轮播广告',
    'en': 'adSet',
    'vn': 'LuckyWin-thông báo nhà cái',
  },
  'gameReport': {
    'zh': 'LuckyWin-游戏报表',
    'en': 'gameReport',
    'vn': 'LuckyWin-Báo cáo trò chơi',
  },
  'platformReport': {
    'zh': 'LuckyWin-平台报表',
    'en': 'platformReport',
    'vn': 'LuckyWin-báo cáo nhà cái',
  },
  'userReport': {
    'zh': 'LuckyWin-用户报表',
    'en': 'userReport',
    'vn': 'LuckyWin-Báo cáo người dùng',
  },
  'cashReport': {
    'zh': 'LuckyWin-资金报表',
    'en': 'cashReport',
    'vn': 'LuckyWin-Báo cáo tài chính',
  },
  'gameUserReport': {
    'zh': 'LuckyWin-游戏用户报表',
    'en': 'gameUserReport',
    'vn': 'LuckyWin-Báo cáo người dùng trò chơi',
  },
  'activityReport': {
    'zh': 'LuckyWin-活动报表',
    'en': 'activityReport',
    'vn': 'LuckyWin-Báo cáo hoạt động',
  },
  'settlementReport': {
    'zh': 'LuckyWin-平台费用结算',
    'en': 'settlementReport',
    'vn': 'LuckyWin-Kết toán chi phí nền tảng',
  },
  'systemUserManage': {
    'zh': 'LuckyWin-用户列表',
    'en': 'systemUserManage',
    'vn': 'LuckyWin-Danh sách người dùng',
  },
  'systemRoleManage': {
    'zh': 'LuckyWin-角色管理',
    'en': 'systemRoleManage',
    'vn': 'LuckyWin-Quản lí cấp bậc',
  },
  'systemPlatformManage': {
    'zh': 'LuckyWin-平台管理',
    'en': 'systemPlatformManage',
    'vn': 'LuckyWin-Quản lí nền tảng',
  },
  'systemPlatformWhiteSetting': {
    'zh': 'LuckyWin-平台IP白名单',
    'en': 'systemPlatformWhiteSetting',
    'vn': 'LuckyWin-Danh sách đen IP trên nền tảng',
  },
  'systemPlatformLogs': {
    'zh': 'LuckyWin-平台日志管理',
    'en': 'systemPlatformLogs',
    'vn': 'LuckyWin-Quản lí nhật ký nền tảng',
  },
  'systemNavManage': {
    'zh': 'LuckyWin-菜单管理',
    'en': 'systemNavManage',
    'vn': 'LuckyWin-Quản lí menu',
  },
  'systemLogs': {
    'zh': 'LuckyWin-日志管理',
    'en': 'systemLogs',
    'vn': 'LuckyWin-Quản lí nhật ký',
  },
  'systemParams': {
    'zh': 'LuckyWin-系统参数设置',
    'en': 'systemParams',
    'vn': 'LuckyWin-Cài đặt tham số hệ thống',
  },
  'systemAppUpdateManage': {
    'zh': 'LuckyWin-客户端更新管理',
    'en': 'systemUpdateManage',
    'vn': 'LuckyWin-Quản lí cập nhật máy khách',
  },
  'systemServerUpdateManage': {
    'zh': 'LuckyWin-服务端更新管理',
    'en': 'systemServerUpdateManage',
    'vn': 'LuckyWin-Quản lí cập nhật máy chủ',
  },
  'systemWhiteSetting': {
    'zh': 'LuckyWin-ip白名单设置',
    'en': 'systemWhiteSetting',
    'vn': 'LuckyWin-Cài đặt danh sách đen IP',
  },
  'systemSensitiveWord': {
    'zh': 'LuckyWin-敏感词管理',
    'en': 'systemSensitiveWord',
    'vn': 'LuckyWin-Quản lí từ nhạy cảm',
  },
  'systemResourceOss': {
    'zh': 'LuckyWin-对象存储',
    'en': 'systemResourceOss',
    'vn': 'LuckyWin-lưu trữ đối tượng',
  },
  'notAuthority': {
    'zh': 'LuckyWin-无权限访问',
    'en': 'notAuthority',
    'vn': 'LuckyWin-Không có quyền truy cập',
  },
  'systemThirdPartySyncInfo': {
    'zh': 'LuckyWin-第三方同步信息',
    'en': 'systemThirdPartySyncInfo',
    'vn': 'LuckyWin-Thông tin đồng bộ thứ ba',
  },
  'systemThirdPartyAmountVerification': {
    'zh': 'LuckyWin-第三方账变核查',
    'en': 'systemThirdPartyAmountVerification',
    'vn': 'LuckyWin-Xác minh thay đổi tài khoản thứ ba',
  },
  'systemThirdPartyReconciliation': {
    'zh': 'LuckyWin-第三方对账',
    'en': 'systemThirdPartyReconciliation',
    'vn': 'LuckyWin-Hòa giải thứ ba',
  },
  'operationLineSet': {
    'zh': 'LuckyWin-客户端线路设置',
    'en': '客户端线路设置',
    'vn': 'LuckyWin-客户端线路设置',
  },
  'activityMsg': {
    'zh': 'LuckyWin-活动列表',
    'en': 'activityMsg',
    'vn': 'LuckyWin-',
  },
  'platformRoleManage': {
    'zh': 'LuckyWin-平台角色管理',
    'en': 'LuckyWin-平台角色管理',
    'vn': 'LuckyWin-平台角色管理',
  },
  'platformUserManage': {
    'zh': 'LuckyWin-平台用户管理',
    'en': 'LuckyWin-平台用户管理',
    'vn': 'LuckyWin-平台用户管理',
  },
}
export default titleList
